import { TableActionsWrapper } from '@components'

import { SearchInput } from '@billy/design-system'
import { ChangeEvent, ReactElement, useCallback } from 'react'

interface DocumentsSearchActionsProps {
  searchQuery: string
  onSearchChange: (query: string) => void
  placeholder: string
}

export const DocumentsSearchActions = ({
  searchQuery,
  onSearchChange,
  placeholder,
}: DocumentsSearchActionsProps): ReactElement => {
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onSearchChange(event.target.value || '')
    },
    [onSearchChange],
  )

  const handleClear = useCallback(() => {
    onSearchChange('')
  }, [onSearchChange])

  return (
    <TableActionsWrapper>
      <SearchInput
        focused={!!searchQuery}
        fullWidth
        onChangeDebounced={handleChange}
        onClear={handleClear}
        placeholder={placeholder}
        value={searchQuery}
      />
    </TableActionsWrapper>
  )
}
